// const config = require('@/utils/config')
// const NODE_ENV = process.env.NODE_ENV
// const { appid } = config[NODE_ENV]

// import router from '../router'
// import store from '../store'
// import { getShareToken } from '@/api/general/wechat'
// import wx from 'weixin-js-sdk'
// import { Toast, Notify } from 'vant'
// import { getToken } from '@/utils/auth'

// import { blackList } from './util'

// router.beforeEach(async (to, from, next) => {
// 	// Set Title
// 	document.title = to.meta.title || 'vue-h5-template'

// 	const hasToken = getToken()
// 	if (hasToken) {
// 		if (to.path === '/login') {
// 			next({ path: '/' })
// 		} else {
// 			const hasUserInfo = store.getters.uid
// 			if (hasUserInfo) {
// 				next()
// 			} else {
// 				try {
// 					// await store.dispatch('user/getInfo')
// 					next()
// 				} catch (error) {
// 					await store.dispatch('user/resetToken')
// 					Toast.fail(error.message || '出错了')
// 					next('/login')
// 				}
// 			}
// 		}
// 	} else {
// 		if (blackList.indexOf(to.path) === -1) {
// 			// console.log(to, from, next)
// 			const url = window.location.href.split('#')[0]
// 			const shareUrl = `${url}#${to.fullPath}`
// 			getShareToken({
// 			  url: shareUrl
// 			}).then(response => {
// 			  wx.config({
// 				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
// 				appId: 'wx6c2349ffd522809f', // 必填，公众号的唯一标识
// 				timestamp: response.data.timestamp, // 必填，生成签名的时间戳
// 				nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
// 				signature: response.data.signature, // 必填，签名，见附录1
// 				jsApiList: [
// 				  'getLocalImgData',
// 				  'chooseImage',
// 				  'chooseWXPay',
// 					'previewImage'
// 				], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
// 				openTagList: ['wx-open-launch-weapp']
// 			  })
// 			  wx.ready(() => {
// 			  })
// 			})
// 			return next()
// 		} else {
// 			Notify({ type: 'primary', message: '请先登录后再操作' })
// 			next('/login')
// 		}
// 	}
// })

// router.afterEach(() => {
// 	Toast.clear()
// })

import router from '../router'
import wx from 'weixin-js-sdk'
import { getToken } from '@/utils/auth'
import { isWXBrowser } from '@/utils/common'
import { handleWxConfig } from '@/utils/handleWxConfig'

const whiteList = ['/', '/login', '/teacher', '/submitPage', '/downLoadForIos', '/promotion', '/recruit', '/agreement', '/extend']

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title
  const hasToken = getToken()
  if (hasToken) {
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      console.log(to)

      if (to.path === '/tutoring') {
        next(`/teacher`)
      } else {
        next(`/login?agentId=${to.query.agentId}`)
      }
    }
  }
})

router.afterEach(async () => {
  // 所有页面都要隐藏分享相关按钮
  if (isWXBrowser) {
    const finalJsApiList = ['getLocalImgData', 'chooseImage', 'chooseWXPay', 'previewImage']
    await handleWxConfig(finalJsApiList)
  }
})
